import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../../assets/DigitalMarketing/image/appoinment/image 1.png";
import mail from "../../../assets/DigitalMarketing/image/appoinment/mail.svg";
import call from "../../../assets/DigitalMarketing/image/appoinment/call.svg";
import logo from "../../../assets/DigitalMarketing/image/appoinment/Logo.svg";
import circle from "../../../assets/DigitalMarketing/image/appoinment/Rectangle 40488.svg";
import { Button } from "@mui/material";
import "../../../assets/DigitalMarketing/Css/Style.css";
import { useNavigate, useParams } from "react-router";
import { Decryption } from "../../../crypto/aes";
import { AppointmentLabel } from "./utils";
import { useEffect, useState } from "react";
import { validateEmail, validatePhone } from "../../../utils";
import {
  useGetAdminProceduresQuery,
  useGetBranchProceduresQuery,
  useGetHospitalsDetailsQuery,
} from "../../../Service/Hospitallanding";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { useDispatch, useSelector } from "react-redux";
import { postregistetHospital } from "../../../Service/api/ApiUrls";
import AppoinmentConfirm from "./AppointmentConfirm";
import { useGetAllBranchesQuery } from "../../../Service/Masters";
import axios from "../../../Service/axios"

function AppoinmentBooking() {
  const { id, role } = useParams();
  let code = Decryption(id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open, message, openSnackBar, type } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  const [show, setShow] = useState(false);
  const [register, setRegister] = useState({
    source: code.split("/")[0],
    hospital_code: code.split("/")[1],
    phoneNumber: "",
    customerName: "",
    email: "",
    serviceChoosen: "",
    branchId: "",
    leadType:""
  });
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const leadOptions = [
    { value: "general", label: "General" },
    { value: "fertility", label: "Fertility" },
  ];
  const response: any = useGetHospitalsDetailsQuery(code.split("/")[1]);
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });
  const { data: adminProcedure } = useGetAdminProceduresQuery(
    register.branchId,
    {
      skip: !register.branchId || role !== "super_admin",
      refetchOnMountOrArgChange: true,
    }
  );
  const { data: branchProcedure } = useGetBranchProceduresQuery({
    skip: role !== "branch",
    refetchOnMountOrArgChange: true,
  });
  const procedureData =
    role === "super_admin" ? adminProcedure : branchProcedure;

  // useEffect(() => {
  //   response?.data?.token &&
  //     localStorage.setItem("appointmenttoken", response?.data?.token);
  // }, [response?.data?.token]);
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    // console.log(name,value);

    setSubmit(false);
    setRegister((prevState) => ({ ...prevState, [name]: value }));
  };
  // console.log(register);

  const onSave = async () => {
    console.log("subitttttttt")
    setSubmit(true);
    if (
      register.customerName.trim().length !== 0 &&
      register.serviceChoosen.trim().length !== 0 &&
      register.phoneNumber.trim().length !== 0 &&
      validatePhone(register.phoneNumber) &&
      validateEmail(register.email)
    ) {
      const payload = {
        ...register,
      };
      if (role !== "super_admin") {
        delete payload.branchId;
      }
      
      try {
        const result = await axios.post(postregistetHospital, payload, {
          headers: {
            Authorization: `Bearer ${response?.data?.data?.token}`,
          },
        });
        // console.log(result.data.data);
        setRegister(result.data.data);
        openSnackBar("Registered successfully");
        setShow(true);
      } catch (err: any) {
        console.log(err);
        openSnackBar(err?.response?.data.error, "error");
      }
    }
  };
  // console.log(response?.data?.data?.treatmentDetails);
  let Option = {
    Service: response?.data?.data?.treatmentDetails,
  };
  // console.log(Option);

  // const activeCategories =
  // Option && Option?.Service.filter((service) => service.activeStatus === 1);

  // const Option_list = {
  //   Service:activeCategories,
  // };
  // console.log(Option_list);
  const Service = [];

  if (Option && Option.Service) {
    for (const service of Option.Service) {
      if (service.activeStatus === 1) {
        Service.push(service);
      }
    }
  }
  const Option_list = {
    Service: Service,
  };
  // console.log(Option_list);

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col xs={11} md={10} className="mt-3">
          {show ? (
            <AppoinmentConfirm
              register={register}
              details={response?.data?.data}
            />
          ) : (
            <>
              <Toast open={open} type={type} message={message} />
              <Row>
                <Col lg={5} className="p-3">
                  <div>
                    <img
                      className="landing-img mb-3"
                      src={response?.data?.data?.templateImage}
                    />
                  </div>
                </Col>
                <Col lg={7} className="p-3">
                  <Row>
                    <Col md={12} className="mb-3">
                      <div className="frame-layout">
                        <div>
                          <div>
                            {/* <img
                              src={response?.data?.data?.hospitalImage}
                              className="circle-img"
                              alt="circle"
                            /> */}
                            <h5 className="landing-head hide px-2">
                              {response?.data?.data?.hospitalName}
                            </h5>
                          </div>
                        </div>
                        <div className="ps-3">
                          <h5 className="landing-head show">
                            {response?.data?.data?.hospitalName}
                          </h5>
                          <small className="landing-body">
                            {response?.data?.data?.address}
                          </small>
                          <div className="mt-3 mb-3 d-flex">
                            <img
                              className="login-logo mt-1"
                              src={mail}
                              alt="mail"
                            />
                            <span>
                              <small className="landing-mail">
                                {response?.data?.data?.emailId}
                              </small>
                            </span>
                            &nbsp; &nbsp;
                            <img
                              className="login-logo mt-1"
                              src={call}
                              alt="call"
                            />
                            <span>
                              <small className="landing-mail">
                                {" "}
                                {response?.data?.data?.mobileNo}
                              </small>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <div className="col-6 mt-2">
                      <div>
                        <label className="form-label">Type</label>
                      </div>

                      <div>
                        <select
                          className="form-control form-select"
                          name="leadType"
                          value={register.leadType}
                          onChange={onHandleChange}
                          // disabled={view}
                        >
                          <option value="">Select</option>
                          {leadOptions?.map((branch, index) => (
                            <option key={index} value={branch.value}>
                              {branch.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {role === "super_admin" && (
                      <div className="col-6 mt-2">
                        <div>
                          <label className="form-label">Branch Name</label>
                        </div>
                        <div>
                          <select
                            className="form-control form-select"
                            name="branchId"
                            value={register.branchId}
                            onChange={onHandleChange}
                            // disabled={view}
                          >
                            <option value="">Select Branch</option>
                            {branchOptions?.data?.map((branch) => (
                              <option key={branch.id} value={branch.id}>
                                {branch.branchName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="col-6 mt-2">
                      <div>
                        <label className="form-label">Treatment type</label>
                      </div>

                      <div>
                        <select
                          className="form-control form-select"
                          name="serviceChoosen"
                          value={register.serviceChoosen}
                          onChange={onHandleChange}
                          // disabled={view}
                        >
                          <option value="">Select</option>
                          {procedureData?.data?.map((branch, index) => (
                            <option key={index} value={branch.procedureTitle}>
                              {branch.procedureTitle}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {AppointmentLabel.map((item: any, index) => {
                      return (
                        <Col
                          lg={item?.width ? item?.width : 6}
                          key={index}
                          className="mt-3"
                        >
                          <item.tag
                            {...item}
                            {...register}
                            handleChange={onHandleChange}
                            newclass="landing-label"
                            submit={submit}
                            opt_list={Option_list}
                            labelStyle="landing-label"
                            style="text-custom-contain-land"
                          />
                        </Col>
                      );
                    })}
                    <Col lg={12} className="mt-5">
                      <div>
                        <Button
                          className="landing btn"
                          id="btn-land"
                          onClick={onSave}
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="footer mb-3">
                <div className="d-flex justify-content-center mt-5">
                  <div className="landing-logo">
                    <img src={logo} />
                  </div>
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default AppoinmentBooking;
